<script setup>
import Titre from "@/components/atoms/titre";
import Card from "@/components/molecules/card";
import LinkTo from "@/components/atoms/link-to";
import LazyImage from "@/components/atoms/lazy-image";
import servicePro from "@/assets/images/services-pro.svg";

const emit = defineEmits(["hidden"]);
const props = defineProps({
  accueil: {
    type: Boolean,
    required: false,
    default: false
  },
  cardPadding: {
    type: String,
    required: false,
    default: "u-p-md"
  }
});
</script>

<template>
  <Card
    radius="lg"
    border-color="border"
  >
    <div
      class="u-flex u-flex-column u-font-14"
      :class="cardPadding"
    >
      <LazyImage
        alt="Corapro"
        height="32"
        :src="servicePro"
        class="u-flex-self-center u-mb-sm"
      />
      <Titre
        tag="p"
        font="primary"
        size="xs"
        class="u-mb-xs"
      >
        Vous êtes un professionnel&nbsp;?
      </Titre>
      <p class="u-mb-sm">
        <template v-if="accueil">
          Pensez au compte services pro pour gagner du temps et bénéficier de services adaptés à votre activité.
        </template>
        <template v-else>
          Pour créer votre compte, rendez-vous sur l'espace <span class="u-font-700">services pro</span> réservé aux professionnels.
        </template>
      </p>
      <LinkTo
        href="/infos-et-services/les-magasins-cora/profitez-des-services/cora-pro"
        variant="primary"
        size="sm"
        @click="emit('hidden')"
      >
        En savoir plus sur services pro
      </LinkTo>
    </div>
  </Card>
</template>

<style lang="scss" scoped>
</style>
